@if (!collapsed()) {
  <button
    type="button"
    class="ps-sidebar-backdrop"
    [attr.aria-label]="backdropDismissLabel()"
    (click)="onDismissOverlay()"
  ></button>
}

<div class="ps-sidebar-panel">
  <header
    class="ps-sidebar-header"
    [class.ps-sidebar-header-collapsed]="collapsed()"
  >
    <ps-button
      class="ps-sidebar-toggle"
      variant="ghost"
      size="md"
      type="button"
      color="dark"
      [id]="toggleId()"
      [ariaExpanded]="!collapsed()"
      [ariaControls]="navRegionId()"
      [ariaLabel]="toggleAriaLabel()"
      (clicked)="onToggleCollapsed()"
    >
      <ps-icon [name]="arrowIcon()" />
    </ps-button>
  </header>

  <div class="ps-sidebar-body">
    <nav
      class="ps-sidebar-nav"
      [id]="navRegionId()"
      [attr.aria-label]="navigationAriaLabel()"
    >
      <div
        class="ps-sidebar-scroll"
        [class.ps-sidebar-scroll-collapsed]="collapsed()"
      >
        <div class="ps-sidebar-nav-stack">
          @for (row of staticNavRows(); track row.trackId) {
            <ps-nav-item
              [icon]="row.item.icon"
              [href]="row.item.href"
              [badgeLabel]="row.item.badge ?? ''"
              [active]="row.item.active ?? false"
              [disabled]="row.item.disabled ?? false"
              [layout]="navItemLayout()"
            >
              {{ row.item.label }}
            </ps-nav-item>
          }
          @if (showNavDivider()) {
            <ps-divider
              class="ps-sidebar-nav-divider"
              orientation="horizontal"
            />
          }
          @for (row of dynamicNavRows(); track row.trackId) {
            <ps-nav-item
              [icon]="row.item.icon"
              [href]="row.item.href"
              [badgeLabel]="row.item.badge ?? ''"
              [active]="row.item.active ?? false"
              [disabled]="row.item.disabled ?? false"
              [layout]="navItemLayout()"
            >
              {{ row.item.label }}
            </ps-nav-item>
          }
        </div>
      </div>
    </nav>
  </div>

  <footer
    class="ps-sidebar-footer"
    [class.ps-sidebar-footer-collapsed]="collapsed()"
    [attr.aria-label]="footerAriaLabel() ?? null"
  >
    <div class="ps-sidebar-footer-brand">
      <ps-logo variant="icon" color="white" size="sm" />
    </div>
    @if (!collapsed()) {
      <div
        class="ps-sidebar-help"
        [attr.aria-labelledby]="helpSectionTitleId()"
      >
        <p [id]="helpSectionTitleId()" class="ps-sidebar-help-title">
          Need help?
        </p>
        <ps-link
          [route]="supportTelUri()"
          [ariaLabel]="supportPhoneAriaLabel()"
          [contentType]="'text'"
          class="ps-sidebar-footer-phone"
        >
          {{ contactLabel }}
        </ps-link>
      </div>
    }
  </footer>
</div>
